/**
 * @group Contact
 * @summary Company phone
 * 
 * @remarks
 * This constant contains the formatted company phone number used for display
 * purposes in contact information and user interfaces.
 * 
 * @example
 * ```typescript
 * import { COMPANY_PHONE } from '@shared/constants';
 * 
 * const phoneDisplay = `Call us: ${COMPANY_PHONE}`;
 * ```
 */
export const COMPANY_PHONE = "021 565 0416"; 